import { useQuery } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from './keys';
import type { Country } from '../types';

/** `GLOBAL` then every ISO 3166-1 country: fixed in code, so it is read once per session. */
export function useCountries({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.countries,
    queryFn: () => api<Country[]>('/api/countries'),
    enabled,
    staleTime: Infinity,
  });
}
